import Vue from "vue";
import * as Fingerprint2 from "fingerprintjs2";

Vue.prototype.$fingerprint = Fingerprint2;

export default {};
